import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { HOME_AFFORDABILITY } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  overridesSelector,
  adjustedOutputsSelector,
} from '../../../lib/selectors/home-affordability-calculator-selectors';
import { HomeAffordabilityInput, inputOnChange } from '../../../lib/utils';
import { debouncedTrackInputEvent } from '../../../lib/analytics/trackers';
import useAnalytics from '../../../lib/analytics/use-analytics';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const DownPaymentInput: React.FC<HomeAffordabilityInput> = ({
  overrides,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip,
  adjustedOutputs,
}) => {
  const segmentAbstract = useAnalytics();
  const value = !_.isNil(overrides?.fundsNeeded)
    ? num.formatCurrency(overrides?.fundsNeeded)
    : '';
  const placeholder = num.formatCurrency(adjustedOutputs?.fundsNeeded);
  const errorMessage = validations?.downPayment?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_type: 'user_type_input',
        field_value: e.target.value,
        entityName: 'down_payment',
        field: 'Down Payment',
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'fundsNeeded',
      overrides: true,
      additionalInputIdsToValidate: ['downPayment'],
      calculator: HOME_AFFORDABILITY,
      inputType: 'currency',
    });
  };

  return (
    <InputMoney
      label={label}
      value={value}
      placeholder={placeholder}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
    />
  );
};

const mapStateToProps = (state) => ({
  overrides: overridesSelector(state),
  validations: validationsSelector(state),
  adjustedOutputs: adjustedOutputsSelector(state),
});

export default connect(mapStateToProps)(DownPaymentInput);
